import React from "react";

export default function ModalComponent({
  children,
  heading,
  searchItemValue,
  searchItemChange,
  clearFilter,
  submitFilter,
  fromDateValue,
  fromDateChange,
  toDateValue,
  toDateChange,
  name,
  page,
  moreWidth
}) {
  return (
    <div className="modal fade" id="sendFilterModal">
      <div className="modal-dialog modal-dialog-centered" style={moreWidth && {maxWidth: '900px'}} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" data-dismiss="modal">
              <span>×</span>
            </button>
          </div>

          <div className="modal-body">
            <form className="comment-form">
             {page != "comments" && <div className="row">
                {fromDateChange && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        From Date{" "}
                        <span className="required">
                          <input
                            type="date"
                            className="form-control"
                            value={fromDateValue}
                            onChange={fromDateChange}
                          />
                        </span>
                      </label>
                      <div className="form-group"></div>
                    </div>
                  </div>
                )}

                {toDateChange && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        To Date
                        <span className="required">
                          <input
                            type="date"
                            className="form-control"
                            value={toDateValue.slice(0, 10)}
                            onChange={toDateChange}
                          />
                        </span>
                      </label>
                      <div className="form-group"></div>
                    </div>
                  </div>
                )}

                {searchItemChange && name != 'deli_boy' && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        {name == "boy" ? "Name / Phone" : name == 'deli_boy' ? 'Name/ID' : "Name"} <span className="required"></span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Search"
                        value={searchItemValue}
                        onChange={searchItemChange}
                      />
                    </div>
                  </div>
                )}

                {children}
              </div>}
             {page == "comments" && 
                <div className="row">
                  {children}
                </div>
              }
              <div className="col-lg-12">
                <div className="form-group mb-0 text-center">
                  <button
                    type="button"
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    className="submit btn btn-primary"
                    // name="submit"
                    onClick={clearFilter}
                  >
                    Clear Filter
                  </button>
                  <button
                    style={{ marginRight: 10 }}
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={submitFilter}
                  >
                    Apply Filter
                  </button>
                  {/* <input
                          type="submit"
                          data-dismiss={"modal"}
                          className="submit btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            getData();
                          }}
                          name="Apply Filter"
                        /> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
